import { Button, IconButton, Text, Tr, Td } from "@chakra-ui/react";
import { DeleteIcon, EditIcon } from '../../../icons';

const MinutesObservationTableRow = ({ observation, minutes, secsPerItem, onRemove, onEdit, disabled }) => {
    return (
        <Tr>
            <Td fontWeight='semi_medium' paddingInline='20px' color='#818197'>
                <Text fontSize='smm' py={2} minW='80px'>{minutes ?? ''}</Text>
            </Td>
            <Td fontWeight='semi_medium' paddingInline='10px' color='#818197'>
                <Text fontSize='smm' py={2} minW='80px'>{secsPerItem ?? ''}</Text>
            </Td>
            <Td fontWeight='semi_medium' paddingInline='20px' w='full'>{observation}</Td>
            { !disabled &&
              <>
                <Td fontWeight='semi_medium' paddingInline='0px'>
                    <Button
                        bg='clientContractorTableRow.button.bg' h='30px' color='clientContractorTableRow.button.color' pl='5px' pr='10px' fontSize='ssm'
                        borderRadius='10px' borderWidth='1px' borderColor='clientContractorTableRow.button.color'
                        onClick={onEdit}>
                        <EditIcon w='12px' h='12px' ml='5px' mr='8px' stroke='clientContractorTableRow.editIcon.stroke' />
                        Edit
                    </Button>
                </Td>
                <Td fontWeight='semi_medium' paddingInline='20px'>
                    <IconButton bg='clientContractorTableRow.deleteIcon.bg' aria-label='delete' size='xs' isRound={true}
                        icon={<DeleteIcon h='15' w='15' stroke='clientContractorTableRow.deleteIcon.stroke' onClick={onRemove} />} />
                </Td>
              </>
            }
        </Tr >
    );
};

export default MinutesObservationTableRow;

export const minutesObservationTableRowStyles = {
    minutesObservationTableRow: {

    }
}
